"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("@chakra-ui/react");
exports.TextField = react_2.forwardRef(function TextField(_a, ref) {
    var { error, errorProps, height, isDisabled, isLoading, keyboard, loadingText, leftAddon, rightAddon, leftButton, leftButtonProps, rightButton, rightButtonProps, leftElement, rightElement, placeholder } = _a, rest = __rest(_a, ["error", "errorProps", "height", "isDisabled", "isLoading", "keyboard", "loadingText", "leftAddon", "rightAddon", "leftButton", "leftButtonProps", "rightButton", "rightButtonProps", "leftElement", "rightElement", "placeholder"]);
    const theme = react_2.useTheme();
    const pattern = react_1.useMemo(() => {
        switch (keyboard) {
            case "numeric":
            case "tel":
                return "[0-9]*";
            default:
                return ".*";
        }
    }, [keyboard]);
    return (react_1.default.createElement(react_2.InputGroup, null,
        leftAddon && (react_1.default.createElement(react_2.InputLeftAddon, { bg: "lightgray.400", borderColor: "lightgray.600", borderRadius: "base", borderWidth: "1px", borderRightWidth: "0px", textStyle: "body1", color: "darkgray.600", fontSize: "sm", height: height || "tall" }, leftAddon)),
        leftElement && (react_1.default.createElement(react_2.InputLeftElement, { color: "lightgray.900", marginLeft: "12px", w: "24px", h: height || "tall" }, leftElement)),
        leftButton && (react_1.default.createElement(react_2.InputLeftAddon, Object.assign({ as: react_2.Button, bg: "white", borderRadius: "8px", borderColor: "lightgray.900", borderWidth: "1px", borderRightWidth: "1px", borderRightColor: "lightgray.900", color: "darkgray.500", height: height || "tall", padding: "14px", _hover: {
                bg: "lightgray.300",
            } }, leftButtonProps), leftButton)),
        react_1.default.createElement(react_2.Input, Object.assign({ autoComplete: "off", bg: "white", borderColor: "lightgray.600", borderWidth: "1px", borderRadius: "base", color: "darkgray.700", fontFamily: "secondary", isDisabled: isDisabled || isLoading, fontSize: "1rem", height: "tall", inputMode: keyboard || "text", paddingLeft: leftElement ? "44px" : "16px", paddingRight: rightElement ? "44px" : "16px", pattern: pattern, placeholder: isLoading ? loadingText || "Carregando..." : placeholder, ref: ref, textStyle: "body1", _focus: {
                border: `1.5px solid ${theme.colors.primary[500]}`,
                boxShadow: `0px 0px 4px ${theme.colors.primary[500]}`,
            }, _hover: {
                borderColor: "darkgray.100",
            }, _placeholder: {
                color: "lightgray.800",
                textStyle: "body1",
                fontFamily: "secondary",
            }, _disabled: {
                bg: "lightgray.300",
                color: "darkgray.300",
                cursor: "not-allowed",
                _hover: {
                    borderColor: "lightgray.600",
                },
            } }, rest, (leftAddon &&
            (isDisabled || isLoading) && {
            borderLeftColor: "lightgray.300",
            _disabled: {
                bg: "lightgray.300",
                cursor: "not-allowed",
                _hover: {
                    borderColor: "lightgray.600",
                    borderLeftColor: "lightgray.300",
                },
            },
        }), (leftAddon &&
            !error &&
            !isDisabled &&
            !isLoading && {
            borderLeftColor: "white",
            _hover: {
                borderColor: "darkgray.100",
            },
        }), (rightAddon &&
            isDisabled && {
            borderRightColor: "lightgray.300",
            _disabled: {
                bg: "lightgray.300",
                cursor: "not-allowed",
                _hover: Object.assign({ borderColor: "lightgray.600", borderRightColor: "lightgray.300" }, (leftAddon && { borderLeftColor: "lightgray.300" })),
            },
        }), (rightAddon &&
            !error &&
            !isDisabled &&
            !isLoading && {
            borderRightColor: "white",
            _hover: {
                borderColor: "darkgray.100",
            },
        }), (leftButton &&
            !isLoading && {
            borderLeftWidth: "1px",
            borderLeftColor: "lightgray.900",
        }), (rightButton &&
            !isLoading && {
            borderRightWidth: "1px",
            borderRightColor: "lightgray.900",
            zIndex: 1,
        }), (error &&
            !isLoading &&
            (rightButton || rightAddon) && {
            borderRightColor: "danger.600",
        }), (error &&
            (leftButton || leftAddon) &&
            !isLoading && {
            borderLeftColor: "danger.600",
            borderLeftWidth: "1px",
        }), (error &&
            !isLoading && Object.assign({ borderColor: "danger.600", _hover: {
                borderColor: "danger.700",
            } }, errorProps)))),
        isLoading && (react_1.default.createElement(react_2.InputRightElement, { color: "lightgray.900", marginRight: "12px", w: "24px", h: height || "tall" },
            react_1.default.createElement(react_2.Spinner, { size: "sm", color: "darkgray.200" }))),
        rightElement && !isLoading && (react_1.default.createElement(react_2.InputRightElement, { color: "lightgray.900", marginRight: "12px", w: "24px", h: height || "tall" }, rightElement)),
        rightAddon && !isLoading && (react_1.default.createElement(react_2.InputRightAddon, { bg: "lightgray.400", borderColor: "lightgray.600", borderRadius: "base", borderWidth: "1px", borderLeftWidth: "0px", color: "darkgray.600", fontSize: "sm", height: height || "tall", textStyle: "body1" }, rightAddon)),
        rightButton && !isLoading && (react_1.default.createElement(react_2.InputRightAddon, Object.assign({ as: react_2.Button, bg: "white", borderRadius: "8px", borderColor: "lightgray.900", borderWidth: "1px", color: "darkgray.500", height: height || "tall", padding: "14px", _hover: {
                bg: "lightgray.300",
            } }, rightButtonProps), rightButton))));
});
//# sourceMappingURL=TextField.js.map